import StatusBadge from "../../../../components/StatusBadge/StatusBadge"


const StatusCell = ({ props }) => {
  return (
    <StatusBadge
      label={props?.formattedValue}
      bgColor={props?.row.statusObj?.bgColor}
      textColor={props?.row.statusObj?.textColor}
    />
  );
}

export default StatusCell;
